// extracted by mini-css-extract-plugin
module.exports = {"LayoutContainer":"📚4-7-03uA1x","ControlAligner":"📚4-7-02eg2u","SubLabel":"📚4-7-03KBJT"};